/* eslint-disable no-new */
import * as types from './mutation-define'
import {axios_get,axios_post} from './axios_operator.js';
const state = {
  // list:[],
  list:[]
}
/*
{
    "_id": "52db532e7e0bac05ef28001a",
    "lastmodify": "2015-08-31T05:34:30.934Z",
    "gid": "5000378998232",
    "name": "奶粉-英国牛栏2段",
    "zhujima": "NF-YGNL2D",
    "in_price": 130,
    "sale_price": 218,
    "category": "55bf66e1bad8be11687eaab3",
    "brand": "55d2a575ed1da14a1639ecfc",
    "enable": true,
    "is_weight": false,
    "unit": "pc",
    "vip_price": {
      "vip": 208
    },
    "same": [],
    "tags": []
  }

*/
// getters
const getters = {
  get_prepare_list: state => state.list,
}


// actions
// const actions = {
//   act_lookup_products_prepare (context,gid) {
//     let url = "/front/api/vip_info?oper=lookup&moblile=" + mobile
//   	axios_get(url,context,{mutation:types.VIP_SET_VIP_INFO,field:'vip'});
//   }
// }

// mutations
const mutations = {
  [types.PRODUCTS_PREPARE_LIST] (state, list) {
    //debugger
    console.log("PRODUCTS_PREPARE_LIST",list);
	 state.list = list?list:[];
  }
}


export default {
  state,
  getters,
  // actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/prepare_store.js